module.exports = __webpack_public_path__ + "img/chek.8fb8154.png";